import { getCustomClientIds as e } from "./generate-client-options.js";
import { getSnippet as t } from "./get-snippet.js";
import { CookieSerializationError as n } from "./operation-to-har/process-parameters.js";
import { operationToHar as r } from "./operation-to-har/operation-to-har.js";
import { getResolvedRef as i } from "@scalar/workspace-store/helpers/get-resolved-ref";
//#region src/code-example/helpers/generate-code-snippet.ts
var a = ({ clientId: a, customCodeSamples: o, includeDefaultHeaders: s = !1, operation: c, method: l, path: u, example: d, contentType: f, server: p, securitySchemes: m, globalCookies: h, openapiVersion: g, requestBodyCompositionSelection: _, defaultDisabledParameters: v }) => {
	try {
		if (!a) return "";
		if (a.startsWith("custom")) {
			let t = e(o), n = o.filter((e, n) => t[n] === a);
			if (!n.some((e) => e.example !== void 0)) return n[0]?.source ?? "Custom example not found";
			let r = i(c.requestBody)?.content ?? {}, s = f ?? Object.keys(r)[0], l = d ?? Object.keys(r[s ?? ""]?.examples ?? {})[0];
			return (n.find((e) => e.example === l && e.contentType === s) ?? n.find((e) => e.example === l && e.contentType === void 0))?.source ?? null;
		}
		let n = r({
			operation: c,
			contentType: f,
			method: l,
			path: u,
			server: p,
			securitySchemes: m,
			example: d,
			globalCookies: h,
			includeDefaultHeaders: s,
			openapiVersion: g,
			requestBodyCompositionSelection: _,
			defaultDisabledParameters: v
		}), [y, b] = a.split("/"), [x, S] = t(y, b, n);
		return x ? (console.error("[generateCodeSnippet]", x), x.message ?? "Error generating code snippet") : S;
	} catch (e) {
		return console.error("[generateCodeSnippet]", e), e instanceof n ? e.message : "Error generating code snippet";
	}
};
//#endregion
export { a as generateCodeSnippet };

//# sourceMappingURL=generate-code-snippet.js.map